import { useNavigate } from "react-router-dom";
import React from "react";
import Header from "../Header/Header.jsx"
import style from "./style.module.css"

const NoPage = ({ toggleWebLanguage, webLanguage, toggleTheme, webTheme, webText, logMeOut }) => {

    const navigate = useNavigate();

    React.useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth', // Smooth scrolling
        });
    }, [])

   return (
     <>
       <Header
         webText={webText}
         toggleTheme={toggleTheme}
         toggleWebLanguage={toggleWebLanguage}
         webLanguage={webLanguage}
         webTheme={webTheme}
         logMeOut={logMeOut}
       />
       <div className={style.page}>
         <main className={style.main}>
          <h1 className={style.errorCode}>404</h1>
          <h2 className={style.title}>Ups! Táto stránka neexistuje.</h2>
          <h3 className={style.text}>Zdá sa, že ste sa dostali na neexistujúcu stránku.</h3>
          <p className={style.backLink}>Späť na
            <span
              className={style.brajo}
              onClick={() => navigate(`/`)}
            >brajo.sk</span></p>
          <div className={style.line}></div>
         </main>
       </div>
     </>
   );
};

export default NoPage;